<template>
  <div
    :class="!$route.meta.topCss ? 'top-menu-container' : 'top-menu-container1'"
  >
    <!-- 左侧Logo或标题 -->
    <div class="menu-logo">
      <!-- <span>重庆财经学院</span> -->
      <img :src="logoUrl" style="width: 240px; margin-top: 10px" alt="" />
    </div>

    <!-- 中间菜单项 -->
    <div class="menu-items">
      <router-link
        v-for="item in menuItems.filter((item) => item.isShow)"
        :key="item.path"
        :to="item.path"
        :class="['menu-item', { 'item-active': $route.path === item.path }]"
        @click.native="handleClick"
      >
        {{ item.name }}
      </router-link>
    </div>

    <!-- 右侧用户信息 -->
    <div class="user-info">
      <!-- <el-button type="text" icon="el-icon-search">{{
        $t("menubar.search")
      }}</el-button> -->
      <!-- <el-button type="text" icon="el-icon-bell" @click="toMessage">{{
        $t("menubar.message")
      }}</el-button> -->
      <el-dropdown style="color: #fff" placement="bottom" v-if="userInfo">
        <el-badge :value="messTotol" class="item" :max="99">
          <span class="user-name">
            {{ $t("menubar.message") }}
          </span>
        </el-badge>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="toMessage('noRead')">
            <i class="el-icon-message"></i>未读消息
            <span style="color: red">({{ noreadTotol }})</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="toMessage('noDoes')">
            <i class="el-icon-notebook-2"></i>待办消息<span style="color: red"
              >({{ nohandleTotol }})</span
            >
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button type="text" icon="el-icon-question">{{
        $t("menubar.instructions")
      }}</el-button> -->
      <!-- <el-button
        icon="el-icon-sort"
        type="normal"
        style="
          border: #fff solid 1px;
          padding: 12px;
          border-radius: 5px;
          color: #6293ff;
        "
        >长辈版</el-button
      > -->
      <el-dropdown style="color: #fff" v-if="userInfo?.userName">
        <span class="user-name">
          <i class="el-icon-user"></i>
          {{ userInfo?.userName }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item @click.native="toPerson">{{
            $t("menubar.profile")
          }}</el-dropdown-item> -->
          <el-dropdown-item @click.native="loginOut">{{
            $t("menubar.logout")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button
        v-else
        type="primary"
        @click="$router.push('/login')"
        style="border: #fff solid 1px; padding: 12px; border-radius: 5px"
        >{{ $t("login.login") }}</el-button
      >
      <el-dropdown style="color: #fff">
        <span class="user-name">
          <!-- <i class="el-icon-user"></i> -->
          {{ language }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="toChinese">中文</el-dropdown-item>
          <el-dropdown-item @click.native="toEnglish">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 隐藏的iframe用于静默请求CAS登录 -->
    <iframe
      ref="casIframe"
      src="https://ywtb.cqtc.edu.cn/cas/login?service=https://sec.cqtc.edu.cn/rump_frontend/loginFromCas/"
      style="display: none"
      @load="onCasIframeLoad"
    ></iframe>
    <iframe
      ref="oaIframe"
      src="https://ywtb.cqtc.edu.cn/login?loginType=web&redirectUrl=https%3A%2F%2Fywtb.cqtc.edu.cn%2Fapi%2Fauth%2Fthird%2Ftd_oa%2Flogin"
      style="display: none"
      @load="onOaIframeLoad"
    ></iframe>
  </div>
</template>

<script>
import topBarLogo from "@/assets/img/topBarLogo.png";
import personalCenter from "@/components/personalCenter/personalCenter.vue";
import { getImageUrl } from "@/utils/imageHelper";
import { mapActions } from "vuex";
import message from "@/views/myAffairs/childCon/message.vue";
import request from "@/api/request";
export default {
  name: "TopMenuBar",
  data() {
    return {
      topBarLogo: topBarLogo,
      // logoImg: "",
      allConfig: [],
      userInfo: null,
      noreadTotol: 0,
      nohandleTotol: 0,
      casRequested: false, // 标记CAS是否已请求,
      oaRequested: false,
    };
  },
  computed: {
    messTotol() {
      return this.noreadTotol + this.nohandleTotol;
    },
    isLogin() {
      // 示例：用户信息存在，且包含 username 字段（根据实际业务调整）
      return !!this.userInfo && !!this.userInfo.userName;
    },
    menuItems() {
      return [
        {
          path: "/Home",
          name: this.$t("menubar.home"),
          isShow: !this.isLogin,
        },
        {
          path: "/myAffairs",
          name: this.$t("menubar.myAffairs"),
          isShow: this.isLogin,
        },
        {
          path: "/effectiveness",
          name: this.$t("menubar.analysis"),
          isShow: true,
        },
        { path: "/guide", name: this.$t("menubar.service"), isShow: true },
        {
          path: "/systems",
          name: this.$t("menubar.systemEntries"),
          isShow: true,
        },
        // { path: "/myAffairs", name: this.$t("menubar.myAffairs") },
        {
          path: "/transactionCenter",
          name: this.$t("menubar.affairs"),
          isShow: true,
        },
        {
          path: "/personalCenter",
          name: this.$t("menubar.profile"),
          isShow: this.isLogin,
        },
      ];
    },
    language() {
      const lang = this.$i18n.locale;
      if (lang == "zh") {
        return "中文";
      } else if (lang == "en") {
        return "English";
      }
      return lang;
    },
    // 计算属性方式
    logoUrl() {
      let logo = null;
      switch (this.$route.path) {
        case "/Home":
          logo = this.allConfig.find((item) => item.name == "电脑端-首页-logo");
          break;
        case "/transactionCenter":
          logo = this.allConfig.find(
            (item) => item.name == "电脑端-事务中心-logo"
          );
          break;
        case "/effectiveness":
          logo = this.allConfig.find(
            (item) => item.name == "电脑端-能效分析-logo"
          );
          break;
        case "/guide":
          logo = this.allConfig.find(
            (item) => item.name == "电脑端-服务指南-logo"
          );
          break;
        case "/systems":
          logo = this.allConfig.find(
            (item) => item.name == "电脑端-常用系统入口-logo"
          );
          break;
        case "/myAffairs":
          logo = this.allConfig.find(
            (item) => item.name == "电脑端-我的事务-logo"
          );
          break;
        case "/personalCenter":
          logo = this.allConfig.find(
            (item) => item.name == "电脑端-个人中心-logo"
          );
          break;
        case "/login":
          logo = this.allConfig.find(
            (item) => item.name == "电脑端-登录页-logo"
          );
          break;
        default:
          logo = this.allConfig.find((item) => item.name == "电脑端-首页-logo");
          break;
      }
      return getImageUrl(logo?.value);
    },
  },
  created() {
    const accountInfo = JSON.parse(localStorage.getItem("accountInfo"));
    if (accountInfo?.data) {
      // 用$set确保响应式更新（即使是整体替换对象）
      this.$set(this, "userInfo", { ...accountInfo.data });

      // 立即打印验证userInfo是否正确赋值
      console.log("登录信息：", this.userInfo);
      console.log("是否登录：", this.isLogin);
      this.getNoreadList();
      this.getNohandleList();

      // 用户登录后自动请求CAS链接
      if (this.userInfo.loginName && !this.casRequested && !this.oaRequested) {
        this.requestCasLogin();
        this.requestOaLogin();
      }
    }
    // console.log(localStorage.getItem("allConfig"));
    const timer = setInterval(() => {
      if (localStorage.getItem("allConfig")) {
        this.allConfig = [...JSON.parse(localStorage.getItem("allConfig"))];

        // for (let i = 0; i <= allData.length; i++) {
        //   if (allData[i]?.name == "电脑端-登录页-logo") {
        //     this.logoImg = allData[i]?.value;
        //     break;
        //   }
        // }
        clearInterval(timer);
      }
    }, 500);
  },
  methods: {
    requestOaLogin() {
      if (this.oaRequested) return;

      this.oaRequested = true;
      console.log("开始请求oa登录链接...");

      // 方法1: 使用隐藏的iframe静默请求
      if (this.$refs.oaIframe) {
        // 重新加载iframe以触发请求
        this.$refs.oaIframe.src = this.$refs.oaIframe.src;
      }

      // 方法2: 使用fetch API请求（可选）
      this.fetchOaLogin();
    },
    fetchOaLogin() {
      const casUrl =
        "https://ywtb.cqtc.edu.cn/login?loginType=web&redirectUrl=https%3A%2F%2Fywtb.cqtc.edu.cn%2Fapi%2Fauth%2Fthird%2Ftd_oa%2Flogin";

      fetch(casUrl, {
        method: "GET",
        mode: "no-cors", // 避免CORS问题
        credentials: "include", // 包含cookie
      })
        .then(() => {
          console.log("OA登录链接请求成功");
        })
        .catch((error) => {
          console.log("OA登录链接请求失败:", error);
          // 即使失败也不影响，因为主要依赖iframe
        });
    },
    // 请求CAS登录链接
    requestCasLogin() {
      if (this.casRequested) return;

      this.casRequested = true;
      console.log("开始请求CAS登录链接...");

      // 方法1: 使用隐藏的iframe静默请求
      if (this.$refs.casIframe) {
        // 重新加载iframe以触发请求
        this.$refs.casIframe.src = this.$refs.casIframe.src;
      }

      // 方法2: 使用fetch API请求（可选）
      this.fetchCasLogin();
    },

    // 使用fetch API请求CAS链接
    fetchCasLogin() {
      const casUrl =
        "https://ywtb.cqtc.edu.cn/cas/login?service=https://sec.cqtc.edu.cn/rump_frontend/loginFromCas/";

      fetch(casUrl, {
        method: "GET",
        mode: "no-cors", // 避免CORS问题
        credentials: "include", // 包含cookie
      })
        .then(() => {
          console.log("CAS登录链接请求成功");
        })
        .catch((error) => {
          console.log("CAS登录链接请求失败:", error);
          // 即使失败也不影响，因为主要依赖iframe
        });
    },

    // iframe加载完成回调
    onCasIframeLoad() {
      console.log("CAS登录iframe加载完成");
    },
    onOaIframeLoad() {
      console.log("oa登录iframe加载完成");
    },

    getNohandleList() {
      request({
        url: `/api/msg/list`,
        method: "post",
        data: {
          pageNum: 1,
          pageSize: 3,
          handle: 0,
        },
      })
        .then((res) => {
          this.nohandleTotol = res?.total;
        })
        .catch((error) => {});
    },
    getNoreadList() {
      request({
        url: `/api/msg/list`,
        method: "post",
        data: {
          pageNum: 1,
          pageSize: 3,
          read: 0,
        },
      })
        .then((res) => {
          this.noreadTotol = res?.total;
          console.log(res);
        })
        .catch((error) => {});
    },
    ...mapActions({
      clearPages: "page/clearPages",
    }),

    getImageUrl(path) {
      return getImageUrl(path);
    },
    toPerson() {
      this.$router.push("/personalCenter");
      // this.$store.dispatch("page/openPage", {
      //   component: personalCenter,
      //   title: this.$t("menubar.profile"),
      //   props: {
      //     category: "all",
      //   },
      // });
    },
    toMessage(data) {
      this.$router.push({
        path: "/message",
        query: { type: data },
      });
      // this.$store.dispatch("page/openPage", {
      //   component: message,
      //   title: this.$t("myAffairs.messageCenter"),
      //   props: {
      //     category: "all",
      //     type: data,
      //   },
      // });
    },
    toChinese() {
      this.$i18n.locale = "zh";
      localStorage.setItem("locale", "zh");
      this.$forceUpdate();
    },
    toEnglish() {
      this.$i18n.locale = "en";
      localStorage.setItem("locale", "en");
      this.$forceUpdate();
    },
    loginOut() {
      this.$store.dispatch("user/logout");
      // 登出时重置CAS请求标记
      this.casRequested = false;
      this.oaRequested = false;
      localStorage.setItem("pwdWarnShowed", "false");
      window.location.reload();
    },
    handleClick() {
      this.clearPages();
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-badge__content.is-fixed {
  right: 3px !important;
  font-size: 10px !important;
}
.top-menu-container,
.top-menu-container1 {
  display: flex;
  align-items: center;
  height: 65px;
  color: black;

  // 默认值(1920x1080及以上)
  padding: 0 20px;

  // 1600x900分辨率
  @media (max-width: 1600px) {
    padding: 0 15px;
  }

  // 1366x768分辨率
  @media (max-width: 1366px) {
    padding: 0 5px;
  }

  background-color: #6293ff;
  box-shadow: 0px 2px 15px 1px rgba(255, 255, 255, 0.2);
  font-size: 15px;
}

.menu-logo {
  // 调整logo宽度响应式
  img {
    width: 380px;
    @media (max-width: 1600px) {
      width: 340px;
    }
    @media (max-width: 1366px) {
      width: 300px;
    }
  }
}

.menu-items {
  flex: 1;
  display: flex;
  flex-direction: row;
  // gap: 10px;
  padding: 0 2%;
  line-height: 65px;
  // 调整菜单项间距
  .menu-item {
    color: #fff;
    //去掉下划线
    text-decoration: none;

    // margin: 0 20px;
    @media (max-width: 1600px) {
      // margin-left: 10px;
      // margin-right: 10px;
    }
    @media (max-width: 1366px) {
      // margin-right: 4px;
      font-size: 14px;
    }
    height: 65px;
    padding: 0 10px;
  }

  .item-active {
    box-shadow: inset 0px -2px 0px #fff;
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.user-info {
  display: flex;
  align-items: center;
  gap: 20px;
  // 调整按钮间距
  .el-button {
    color: #fff;
    ::v-deep .el-icon-sort {
      transform: rotate(90deg);
    }
  }
}
</style>
